// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import ReactLoader from './../core/ReactLoader';
var _languageLoaded = false;
var _mounted = false;
var _language = '';

abstract class BaseAppComponent<P, S> extends React.Component<P, S> {
    _appLoaded: boolean;
    _errorStatus: number;
    constructor(language: string, props?: P, context?: any) {
        super(props, context);

        this._checkForLoad = this._checkForLoad.bind(this);
        this._globalLoaded = this._globalLoaded.bind(this);
        this._languageLoaded = this._languageLoaded.bind(this);
        this.isLocaleLoaded = this.isLocaleLoaded.bind(this);
        this._handlePermissionError = this._handlePermissionError.bind(this);
        this.componentWillMountBase = this.componentWillMountBase.bind(this);
        this._appLoaded = false;
        this._errorStatus = -1;

        _language = language;
        _languageLoaded = false;
        _mounted = false;
        InovxLoader.loadedOnce(this._globalLoaded);
    }

    protected abstract _initialize(): void;

    private _globalLoaded() {
        InovxLoader.addLanguage(_language, this._languageLoaded);
    }
    
    private _languageLoaded() {
        _languageLoaded = true;
        this._checkForLoad();
    }

    private _checkForLoad() {
        if (_mounted && _languageLoaded) {
            this._initialize();
        }
    }

    protected _handlePermissionError(error: IServiceErrorObject) {
        this._errorStatus = error.status;
        this.setState({} as any);
    }

    isAppLoaded() {
        return this._appLoaded && _languageLoaded;
    }

    isLocaleLoaded() {
        return _languageLoaded;
    }

    componentWillMountBase() {
        _mounted = true;
        this._checkForLoad();
    }
}

export default BaseAppComponent;